@if (showVoiceOptions) {
  <div class="voice-selection">
    <div class="voices-provider-list">
      <h4 class="header">Choose Voice Sample Provider</h4>
      <ul
        class="voice-provider-selection"
        [ngClass]="(docTTSControlReq$ | async) ? 'audio-controls-open' : 'audio-controls-closed'"
        >
        @for (voiceProvider of ttsVoiceProvider; track voiceProvider) {
          <li
            data-automation-id="tts-voice-provider-item"
            class="voice-provider-list-items"
          [ngClass]="{
              'voice-selection-opt': (isLoading$ | async) === false,
              'voice-selection-opt-selected': voiceProvider.provider === ttsProviderSelected,
              'voice-selection-disabled': (isLoading$ | async)
            }"
            (click)="onReadProviderVoicePickClick(voiceProvider)"
            >
            {{ voiceProvider.name }}
          </li>
        }
      </ul>
    </div>
    @if (ttsProviderSelected === TTSVoiceProviders.AZURE) {
      <div class="azure-voices-list">
        <h4 class="header">Azure Voice Sampler</h4>
        <ul
          class="azure-voice-selection"
          [ngClass]="(docTTSControlReq$ | async) ? 'audio-controls-open' : 'audio-controls-closed'"
          >
          @for (voice of azureTtsVoices; track voice) {
            <li
              data-automation-id="tts-azure-voice-item"
            [ngClass]="{
              'voice-selection-opt': (isLoading$ | async) === false,
              'voice-selection-opt-selected': voice.name === (selectedVoice$ | async),
              'voice-selection-disabled': (isLoading$ | async)
            }"
              (click)="onReadVoicePickClick(voice)"
              >
              {{ voice.display }}
            </li>
          }
        </ul>
      </div>
    } @else {
      <div class="readspeaker-voices-list">
        <h4 class="header">Readspeaker Voice Sampler</h4>
        <ul
          class="readspeaker-voice-selection"
          [ngClass]="(docTTSControlReq$ | async) ? 'audio-controls-open' : 'audio-controls-closed'"
          >
          @for (voice of rsTtsVoices; track voice) {
            <li
              data-automation-id="tts-readspeaker-voice-item"
            [ngClass]="{
              'voice-selection-opt': (isLoading$ | async) === false,
              'voice-selection-opt-selected': voice.name === (selectedVoice$ | async),
              'voice-selection-disabled': (isLoading$ | async)
            }"
              (click)="onReadVoicePickClick(voice)"
              >
              {{ voice.display }}
            </li>
          }
        </ul>
      </div>
    }
  </div>
}
<button
  class="tts-controls-button"
  mhe-button
  [purpose]="ButtonPurpose.Icon"
  data-automation-id="read-aloud-voice-button"
  [mheTooltip]="'readspeaker.read_aloud_voice' | translate"
  [placement]="'bottom'"
  (click)="onReadVoiceClick()"
  >
  <i class="dpg-icon dpg-icon-cog"></i>
</button>
